/* TrendDrop — FAQ list: "swipe cards" mobile mode keeps every answer open; editor block select opens it. */
(() => {
  if (window.__tdPagesInit) return;
  window.__tdPagesInit = true;

  if (!customElements.get('td-faq-list')) {
    class TdFaqList extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mobile !== 'cards') return;
        this.mq = window.matchMedia('(max-width: 749px)');
        this.sync = this.sync.bind(this);
        this.mq.addEventListener('change', this.sync);
        this.sync();
      }
      disconnectedCallback() {
        this.mq?.removeEventListener('change', this.sync);
      }
      sync() {
        const items = this.querySelectorAll('details');
        if (this.mq.matches) {
          items.forEach((d) => {
            if (!d.open) {
              d.dataset.tdAutoOpen = 'true';
              d.open = true;
            }
          });
        } else {
          items.forEach((d) => {
            if (d.dataset.tdAutoOpen) {
              d.open = false;
              delete d.dataset.tdAutoOpen;
            }
          });
        }
      }
    }
    customElements.define('td-faq-list', TdFaqList);
  }

  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('.td-faq__item');
    if (item) item.open = true;
  });
})();
